import { Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import MoneyWithCurrency from 'modules/core/lib/money'

import type { ExpensableGroup } from './types'

interface AmountProps {
  amount: ExpensableGroup['amount']
  currency: ExpensableGroup['currency']
}

export const Amount = ({ amount, currency }: AmountProps) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Text.Normal size="200">
      {MoneyWithCurrency({
        optionalDecimals: true,
        amount: Number(amount),
        currency,
        locale,
      })}
    </Text.Normal>
  )
}
